import React, { useRef, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import { TextField, Checkbox } from 'formik-material-ui';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ru';
import {
    DatePicker,
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MaskedInput from 'react-text-mask';
import {
    cadastrarCrianca,
    atualizaCriancas,
    getCriancasById,
} from '../../services/GruposApi';
import {
    Card,
    CardContent,
    AppBar,
    Toolbar,
    Typography,
} from '@material-ui/core';
import InformationDialog from '../../components/InformationDialog';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
            ]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

function DateMask(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

const useStyles = makeStyles(theme => ({
    avatar: {
        width: theme.spacing(15),
        height: theme.spacing(15),
        margin: 'auto',
    },
    photoButton: {
        marginTop: theme.spacing(1),
        maxWidth: 200,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    button: {
        marginTop: 24,
        margin: theme.spacing(1),
    },
}));

export default function CadastrarCrianca(props) {
    const dateRgex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
    const classes = useStyles();
    const history = useHistory();
    const inputEl = useRef(null);
    const [crianca, setCrianca] = useState(undefined);
    const { idMembro, idCrianca } = useParams();
    const [selectedImage, setSelectedImage] = useState('');
    const [informacao, setInformacao] = useState(false);
    function handleCancelar() {
        history.goBack();
    }

    async function fetchCriancaById(idCrianca) {
        try {
            const response = await (await getCriancasById(idCrianca)).data;
            setCrianca(response);
        } catch (error) {
            console.error(error);
        }
    }

    const handleCadastrar = async (values, { setSubmitting }) => {
        if (!crianca) {
            try {
                const crianca = {
                    txNome: values.txNome,
                    dtNascimento: values.dtNascimento,
                    idMembroLiderProfessor: idMembro,
                };
                const response = await cadastrarCrianca(crianca);
                history.goBack();
            } catch (err) {
                setInformacao(true);
            }
        } else {
            try {
                const membroTemp = {
                    id: crianca.id,
                    txNome: values.txNome,
                    dtNascimento: values.dtNascimento,
                    idMembroLiderProfessor: idMembro,
                };
                const response = await atualizaCriancas(idCrianca, membroTemp);
                history.goBack();
            } catch (err) {
                if (err.response.status === 500) {
                    setInformacao(true);
                }
            }
        }

        setSubmitting(false);
    };

    useEffect(() => {
        if (!!idCrianca && !crianca) {
            fetchCriancaById(idCrianca);
        }
    }, [idCrianca]);

    const telefoneParser = txTelefone => {
        if (!!txTelefone) {
            const telefone = txTelefone
                .normalize('NFD')
                .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
            if (telefone.length !== 9 && telefone.length !== 11) {
                return '';
            } else {
                if (telefone.length === 9) {
                    return '(92) ' + txTelefone;
                } else {
                    return txTelefone;
                }
            }
        }
        return '';
    };

    const handleClose = () => {
        setInformacao(false);
    };

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    <Typography color="secondary" variant="h5">
                        {!crianca ? 'Cadastrar Criança' : 'Atualizar Criança'}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Card>
                <CardContent>
                    <Formik
                        enableReinitialize
                        initialValues={
                            !crianca
                                ? {
                                      txNome: '',
                                      dtNascimento: undefined,
                                  }
                                : {
                                      txNome: crianca.txNome,
                                      dtNascimento: crianca.dtNascimento,
                                  }
                        }
                        onSubmit={(values, { setSubmitting }) => {
                            handleCadastrar(values, { setSubmitting });
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={Yup.object().shape({
                            dtNascimento: Yup.string()
                                .matches(dateRgex, 'Data Invalída')
                                .nullable('Data Invalída')
                                .required('Data Invalída'),
                            txNome: Yup.string().required('Digite o Nome'),
                        })}
                    >
                        {props => {
                            const {
                                touched,
                                errors,
                                isSubmitting,
                                submitForm,
                                values,
                                setFieldValue,
                            } = props;
                            return (
                                <form noValidate autoComplete="off">
                                    <Grid container direction="row">
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                label="Nome"
                                                required
                                                name="txNome"
                                                fullWidth
                                                className={classes.formControl}
                                                helperText={
                                                    errors.txNome &&
                                                    touched.txNome &&
                                                    errors.txNome
                                                }
                                                inputProps={{
                                                    style: {
                                                        textTransform:
                                                            'uppercase',
                                                    },
                                                }}
                                                autoFocus
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                label="Data de Nascimento"
                                                name="dtNascimento"
                                                required
                                                InputProps={{
                                                    inputComponent: DateMask,
                                                }}
                                                helperText={
                                                    errors.dtNascimento &&
                                                    touched.dtNascimento &&
                                                    errors.dtNascimento
                                                }
                                                className={classes.formControl}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                onClick={submitForm}
                                                color="primary"
                                                disabled={isSubmitting}
                                                className={classes.button}
                                            >
                                                Salvar
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleCancelar}
                                                disabled={isSubmitting}
                                                className={classes.button}
                                                type="button"
                                            >
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            );
                        }}
                    </Formik>
                </CardContent>
            </Card>
            <InformationDialog
                titulo={'Cadastrar Membro'}
                handleClose={handleClose}
                open={informacao}
            >
                Já existe um crianca cadastrado com os dados informados. Se você
                pesquisou e não localizou, verifique os dados informados na
                pesquisa e tente novamente. Se precisar de ajuda entre em
                contato via Whatsapp pelo número <b>99205-0094</b> ou envie um
                e-mail para <b>cadastro@nib.org.br</b>.
            </InformationDialog>
        </>
    );
}
